<template>
    <div class="">
      <banner type="7"></banner>
        <productList :recommend-show="false" :product-list="petList" product-name="宠物检测"></productList>
    </div>
</template>
<script>
    import productList from "../ENComponents/productList";

    export default {
        name: 'pets',
        components: {
            productList
        },
        data() {
            return {
                petList:[]
            }
        },
        async mounted() {
            this.getTesting()
        },
        methods: {
            async getTesting(){
                this.petList = await this.$api.getTesting()
            }
        }
    }
</script>
<style scoped lang="scss">

</style>
